// API related actions
export const FETCH_PART_PRICE_INFO_REQUEST = '@@toyota/FETCH_PART_PRICE_INFO_REQUEST';
export const FETCH_PART_PRICE_INFO_FAILED = '@@toyota/FETCH_PART_PRICE_INFO_FAILED';
export const FETCH_PART_PRICE_INFO_SUCCESS = '@@toyota/FETCH_PART_PRICE_INFO_SUCCESS';

// Complementary actions
export const CLEAR_PRICE_AND_FOB = '@@toyota/CLEAR_PRICE_AND_FOB';
